import simbApi from ".";
import { SHARE_COLUMN_BACKFILL } from "../../data/constants/endpoints";

export interface ShareColumnBackfillRequest {
  columnTitle: string;
  columnType: string;
  /** Boards that already hold the column, the one to copy from first, each with its column id. */
  sourceBoards: { boardId: string; columnId: string }[];
  targetBoardIds: string[];
  dryRun?: boolean;
}

export interface ShareColumnBackfillResponse {
  itemCount: number;
  perTargetBoard: Record<string, number>;
  /** Null for a dry run or when there was nothing to fill. */
  requestId: string | null;
  columnKey?: string | null;
}

/** 409 from the backend: orchestration force push is off, so values can't be copied. */
export const BACKFILL_UNAVAILABLE_CODE = "force_push_disabled";

export const shareColumnBackfill = async (
  accessToken: string,
  body: ShareColumnBackfillRequest,
): Promise<ShareColumnBackfillResponse> => {
  const response = await simbApi.post(SHARE_COLUMN_BACKFILL, body, {
    headers: { Authorization: `Bearer ${accessToken}` },
    // Queuing a large board's events can take a few seconds; the default timeout would cut it.
    timeout: 0,
  });

  return response.data;
};
